import { NO_DISEASE_GROUP_NAME, VacciantionData, VaccinationGroup } from '../VaccinationTable';
import { groupVaccinationsByDisease } from '@patient/ui/EhrPage/pages/VaccinationPage/utils/groupVaccinationsByDisease';

export interface UseVaccinationDataProps {
    vaccinations: VacciantionData[];
}

interface UseVaccinationDataData {
    vaccinationGroups: VaccinationGroup[];
}

export function useVaccinationData({ vaccinations }: UseVaccinationDataProps): UseVaccinationDataData {
    return {
        vaccinationGroups: groupVaccinationsByDisease<VacciantionData>(vaccinations, NO_DISEASE_GROUP_NAME()),
    };
}
